export const forEachItem = (k, callback) => {
  for (let i = 0; i < window.localStorage.length; i++) {
    const localKey = window.localStorage.key(i);
    if (localKey.startsWith(k)) {
      const ret = callback(localKey);
      if (ret) {
        return;
      }
    }
  }
};

export const findKey = (k) => {
  let localKey;
  forEachItem(k, (_k) => {
    localKey = _k;
    return true;
  });

  return localKey;
};

export const sortKeyList = (allKeys) => {
  return allKeys.sort((a, b) => {
    if (a.order < b.order) {
      return -1;
    } else if (a.order > b.order) {
      return 1;
    }

    return 0;
  });
};
